<template>
  <div>
    <Nav />
    <h1>Enterprise Projects</h1>
    <div class="row">
      <div class="col s2">
        <div class="side-nav">
          <a href="#about">Enterprises</a>
          <hr>
          <a href="#services">Projects</a>
          <hr>          
          <a href="#clients">College Courses</a>
          <hr>          
          <!-- <a href="#contact">Contact</a> -->
        </div>
      </div>
      <div id="about" class="col s10">
        <div v-for="(proj, index) in Enterprises" :key="index">
          <div class="row">
            <div class="col s3">
              <img :src="proj.icon" class="company-logo" alt srcset />
            </div>
            <div class="col s3">
              <h5>Company:</h5>
              {{proj.company}}
            </div>
            <div class="col s3">
              <h5>Date:</h5>
              {{proj.date}}
            </div>
            <div class="col s3">
              <h5>Company Website:</h5>
              <a :href="proj.URL">
                <i class="material-icons">launch</i>
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <h5>Position:</h5>
              {{proj.position}}
            </div>
            <div class="col s12">
              <h5>Project Description:</h5>
              {{proj.desc}}
            </div>
            <div class="col s12">
              <h5>Tech:</h5>
              {{proj.tech}}
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <h2>Projects</h2>


    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ExperiencePage",
  components: {
    Nav,
    Footer
  },
  data() {
    return {
      Enterprises: [
        {
          id: 1,
          company: "DealerTrack",
          position:
            "DealerTrack - Developer - Externship (Neumont Collaborative Project)",
          tech: "Selenium C#, GitHub, VS 2017",
          desc:
            "Building automated tests and configuring an automation framework" +
            "for auto dealership software. Worked on creating new automation processes and refactoring configurations to help with test efficiency. All done using Selenium, C#.",
          date: "April 2019 - June 2019",
          URL: "https://us.dealertrack.com",
          icon: "/dt.png"
        },
        {
          id: 2,
          company: "JourneyTeam",
          position:
            "JourneyTeam - Developer - Externship (Neumont Collaborative Project)",
          tech: "TypeScript, Azure Repos, VS Code",
          desc:
            "Development testing and coordinating test cases for system functionality.",
          date: "June 2019 - August 2019",
          URL: "https://www.journeyteam.com",
          icon: "/jt.png"
        },
        {
          id: 3,
          company: "Control4",
          position:
            "Control4 - Developer - Externship (Neumont Collaborative Project)",
          tech: "MS Office",
          desc: "Regulatory compliance testing.",
          date: "October 2019 - December 2019",
          URL: "https://www.control4.com",
          icon: "/ls.png"
        }
      ]
    };
  },
  methods: {},
  beforeMount() {
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".collapsible");
      var instances = M.Collapsible.init(elems, {});
    });
  }
};
</script>

<style>
.company-logo {
  height: 64px;
  width: 64px;
}
.collapsible-body {
  background: rgb(219, 217, 217);
}

.side-nav {
  height: 50%;
  width: 160px;
  position: fixed;
  z-index: 1;
  top: 5;
  left: 0;
  /* background-color: rgb(240, 116, 116); */
  overflow-x: hidden;
  padding-top: 10px;
}

.side-nav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #e02f2f;
  display: block;
}

.side-nav a:hover {
  color: #f1f1f1;
}
</style>
